import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { convertDataAnswerGraph, replacePathParams } from 'libs/helpers/functions';
import { useDispatch, useSelector } from 'react-redux';
import { EPath } from 'constants/routes';
import { answersAction } from 'modules/answers/answers.action';
import { TAnswerControlSubmit, TControlAnswer } from 'types/assignments';
import { AppState } from 'store';
import { getControlAnswersFromLS } from 'libs/helpers/localStorageFn';
import AssignmentsControlGraph from './AssignmentsControlGraph';

const AssignmentsControlGraphContainer = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmitAnswerControlTask = useCallback(
    (data: TAnswerControlSubmit) => {
      dispatch(answersAction.submitAnswerControlTask(data));
    },
    [dispatch],
  );
  const controlAnswersFromLS = getControlAnswersFromLS(id);
  const dataStudentAnswer = useSelector((state: AppState) => state.pages.answers.dataSimulations?.studentSimulation);
  const answersState = useSelector((state: AppState) => state.pages.answers);
  const { currentUser } = useSelector((state: AppState) => state.pages.auth);

  const handleClickPre = () => history.push(replacePathParams(EPath.U8_1_2, { id }));

  const controlAnswers: TControlAnswer[] = controlAnswersFromLS.map((it: TControlAnswer) => {
    const dataAnswer = {
      alias: it.alias,
      factorial: it.factorial,
      morningData: it.morningData ? parseFloat(it.morningData.toString() || '0') : 0,
      afternoonData: it.afternoonData ? parseFloat(it.afternoonData.toString() || '0') : 0,
      beforeNightData: it.beforeNightData ? parseFloat(it.beforeNightData.toString() || '0') : 0,
      midnightData: it.midnightData ? parseFloat(it.midnightData.toString() || '0') : 0,
      unit: it.unit,
      month: it.month,
    };
    return dataAnswer;
  });

  const studentAnswerCheckNotDoing = convertDataAnswerGraph(controlAnswersFromLS);

  const getResults = (id: string, sid: string) => {
    dispatch(answersAction.getResultAssignmentOneStudent({ id, sid }));
  };

  return (
    <AssignmentsControlGraph
      handleSubmitAnswerControlTask={handleSubmitAnswerControlTask}
      handleClickPre={handleClickPre}
      getResults={getResults}
      answersState={answersState}
      controlAnswers={controlAnswers}
      assignmentId={id}
      currentUser={currentUser}
      dataStudentAnswer={dataStudentAnswer}
      studentAnswerCheckNotDoing={studentAnswerCheckNotDoing}
    />
  );
};

export default AssignmentsControlGraphContainer;
